import { client } from 'src/utils/client'
import config from 'src/config'
import { City } from 'src/store/models/user'

export const getCity = async (queryParam: string): Promise<City[]> =>
  await client(`${config.HOST_API}/cities${queryParam}`)
